export default __webpack_public_path__ + "static/media/FAQ_3.131416b1.png";